export const ALLOWED_VISIT_TYPE_IDS = [
    456, 457, 458, 459, 460, 466, 473, 479, 480, 482, 483, 485, 486, 487, 488, 489, 490
];

export const ALLOWED_VISIT_TYPE_IDS_SET = new Set(ALLOWED_VISIT_TYPE_IDS);
